var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"answer-formula",attrs:{"tabindex":"0"}},[_c('katex-text',{staticClass:"answer-formula__text",attrs:{"src":_vm.outputSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }